import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "relative grow" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "relative h-auto"
}
const _hoisted_4 = { class: "mt-3" }

import {
  computed,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from 'vue';
import ChatInput from '@/components/ChatInterface/ChatThread/ChatInput.vue';
import InstructionActions from '@/components/ChatInterface/ChatThread/InstructionActions.vue';
import InstructionMsgs from '@/components/ChatInterface/ChatThread/InstructionMsgs.vue';
import MessageList from '@/components/ChatInterface/ChatThread/MessageList.vue';
import InfiniteScroll from '@/components/Helper/InfiniteScroll.vue';
import CustomLoader1 from '@/components/Helper/Loader/CustomLoader1.vue';
import {
  type ConversationThreadService,
  getConversationThreadService,
} from '@/services/ConversationThreadService';
import {
  useStore,
} from '@/store';

type ScrollBehavior = 'auto' | 'instant' | 'smooth';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatThreadUi',
  setup(__props) {


let conversationThreadService: ConversationThreadService;

const utilStore = useStore.util;
const conversationThreadStore = useStore.conversationThread;
const conversationHistoryStore = useStore.conversationHistory;
const createdBefore = new Date().toISOString();

const hasThreadMsg = computed(() => !!conversationThreadStore.messages.length);

const conversationDiv = ref<HTMLDivElement | null>(null);
const chatInputDiv = ref<HTMLDivElement | null>(null);

let prevChatInputHeight = 0;
let currentConversationPage = 0;

async function loadConversations(): Promise<void> {
  if (!conversationThreadStore.uuid || !utilStore.isHistoryChat) {
    return;
  }

  const earlierConversationScrollHeight = conversationDiv.value?.scrollHeight || 0;

  const { loadCount } = await conversationThreadService
    .loadPreviousConversations(currentConversationPage + 1, createdBefore);

  if (loadCount) {
    const totalConversationScrollHeight = conversationDiv.value?.scrollHeight || 0;

    // go close to earlier position
    _scrollConversationMessage('instant', totalConversationScrollHeight - earlierConversationScrollHeight);
    currentConversationPage += 1;
  }
}

function adjustConversationHeight(): void {
  if (!conversationDiv.value || !chatInputDiv.value) {
    return;
  }

  const chatInputHeight = chatInputDiv.value.offsetHeight;
  const conversationHeight = conversationDiv.value.offsetHeight;

  if (chatInputHeight !== prevChatInputHeight) {
    const heightDifference = chatInputHeight - prevChatInputHeight;
    conversationDiv.value.style.height = `calc(${conversationHeight}px - ${heightDifference}px)`;
  }

  prevChatInputHeight = chatInputHeight || 0;
}

function _scrollConversationMessage(
  behavior: ScrollBehavior,
  top = conversationDiv.value?.scrollHeight,
): void {
  conversationDiv.value?.scrollTo({
    behavior,
    top,
  });
}

watch(() => utilStore.notification === undefined, () => {
  if (conversationDiv.value) {
    conversationDiv.value.style.height = '360px';
  }
});

watch(() => conversationThreadStore.messages, () => {
  if (!conversationThreadStore.isReplyLoading || !conversationThreadStore.messages.length) {
    return;
  }

  if (conversationDiv.value) {
    conversationDiv.value.style.height = '360px';
  }

  // reply is being added with conversation message, go to bottom
  _scrollConversationMessage('instant');
});

watch(() => conversationThreadStore.isReplyLoading, (x, y) => {
  // if reply loading starts or ends, go to bottom of conversation
  adjustConversationHeight();
  setTimeout(() => {
    _scrollConversationMessage('instant');
  }, 1000 * 0.25);
});

onMounted(async () => {
  conversationThreadService = getConversationThreadService();

  loadConversations();
  adjustConversationHeight();
});

onUnmounted(() => {
  utilStore.isHistoryChat = false;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(conversationHistoryStore).isLoading)
      ? (_openBlock(), _createBlock(CustomLoader1, {
          key: 0,
          class: "flex h-full"
        }))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["relative", _unref(utilStore).notification ? 'h-92' : 'h-104'])
        }, [
          _createElementVNode("div", {
            ref_key: "conversationDiv",
            ref: conversationDiv,
            class: _normalizeClass(["h-full", { 'overflow-y-auto': hasThreadMsg.value }])
          }, [
            (_unref(conversationThreadStore).isHistoryLoading)
              ? (_openBlock(), _createBlock(CustomLoader1, {
                  key: 0,
                  class: "flex h-full"
                }))
              : (!hasThreadMsg.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(InstructionMsgs),
                    _createVNode(InstructionActions)
                  ]))
                : _createCommentVNode("", true),
            (hasThreadMsg.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(InfiniteScroll, { onLoad: loadConversations }, {
                      bottom: _withCtx(() => [
                        _createVNode(MessageList)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            ref_key: "chatInputDiv",
            ref: chatInputDiv,
            class: "absolute bottom-0 w-full bg-white"
          }, [
            _createVNode(ChatInput, {
              class: "px-4",
              onInput: adjustConversationHeight
            })
          ], 512)
        ], 2))
  ]))
}
}

})